import { render } from "./VueEditor.vue?vue&type=template&id=f0ff5ac4"
import script from "./VueEditor.vue?vue&type=script&lang=js"
export * from "./VueEditor.vue?vue&type=script&lang=js"

import "quill/dist/quill.snow.css?vue&type=style&index=0&lang=css"
import "./assets/vue3-editor.css?vue&type=style&index=1&lang=css"
script.render = render

export default script